/* Acquisto rapido dai punti degli outfit - Il Pellicano */
(function () {
  if (window.__plOutfit) return;
  window.__plOutfit = true;

  var css = '.pl-qv{border:0;padding:0;width:min(880px,94vw);max-height:92vh;background:#fff;color:#1c1c1c;overflow:auto}.pl-qv::backdrop{background:rgb(0 0 0/.4)}' +
    '.pl-qv__x{position:absolute;right:.9rem;top:.6rem;font-size:1.9rem;line-height:1;background:none;border:0;cursor:pointer;color:inherit;z-index:2}' +
    '.pl-qv__body{display:grid;grid-template-columns:1fr 1fr}.pl-qv__img{background:#f4f4f2;min-height:320px}.pl-qv__img img{width:100%;height:100%;object-fit:cover;display:block;max-height:80vh}' +
    '.pl-qv__info{padding:2.5rem 2rem 2rem;display:grid;gap:1.1rem;align-content:start}' +
    '.pl-qv__t{margin:0;font-size:1rem;letter-spacing:.06em;text-transform:uppercase;font-weight:500}.pl-qv__p{margin:0;font-size:.9375rem}' +
    '.pl-qv__opt{display:grid;gap:.5rem}.pl-qv__ol{font-size:.6875rem;letter-spacing:.1em;text-transform:uppercase;color:rgb(0 0 0/.6)}' +
    '.pl-qv__vals{display:flex;flex-wrap:wrap;gap:.45rem}.pl-qv__v{min-width:2.9rem;padding:.55rem .8rem;border:1px solid rgb(0 0 0/.25);background:#fff;font-size:.75rem;cursor:pointer;color:inherit}' +
    '.pl-qv__v[aria-pressed=true]{background:#1c1c1c;color:#fff;border-color:#1c1c1c}.pl-qv__v:disabled{opacity:.35;text-decoration:line-through;cursor:not-allowed}' +
    '.pl-qv__btn{display:block;width:100%;padding:.95rem 1rem;font-size:.75rem;letter-spacing:.12em;text-transform:uppercase;border:1px solid #1c1c1c;cursor:pointer}' +
    '.pl-qv__btn--a{background:#fff;color:#1c1c1c}.pl-qv__btn--b{background:#1c1c1c;color:#fff}.pl-qv__btn:disabled{opacity:.4;cursor:not-allowed}' +
    '.pl-qv__msg{font-size:.8125rem;min-height:1.2em;margin:0}.pl-qv__msg a{text-decoration:underline;text-underline-offset:3px}.pl-qv__full{font-size:.75rem;text-decoration:underline;text-underline-offset:4px;justify-self:start}' +
    '@media(max-width:699px){.pl-qv__body{grid-template-columns:1fr}.pl-qv__img{min-height:0;max-height:42vh}.pl-qv__info{padding:1.5rem 1.25rem}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var money = function (c) { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100); };
  var dlg, prod, sel, vBtn, msg;

  function ensure() {
    if (dlg) return;
    dlg = document.createElement('dialog'); dlg.className = 'pl-qv';
    dlg.innerHTML = '<button type="button" class="pl-qv__x" aria-label="Chiudi">×</button><div class="pl-qv__body"><div class="pl-qv__img"></div><div class="pl-qv__info"></div></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('.pl-qv__x').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  function current() {
    return prod.variants.find(function (v) { return sel.every(function (s, i) { return v['option' + (i + 1)] === s; }); });
  }

  function render() {
    var info = dlg.querySelector('.pl-qv__info');
    var v = current();
    var img = (v && v.featured_image && v.featured_image.src) || prod.featured_image;
    dlg.querySelector('.pl-qv__img').innerHTML = img ? '<img src="' + img + '" alt="">' : '';
    var h = '<h3 class="pl-qv__t"></h3><p class="pl-qv__p">' + (v ? money(v.price) : money(prod.price)) + '</p>';
    prod.options.forEach(function (o, i) {
      if (o.values.length === 1 && o.values[0] === 'Default Title') return;
      h += '<div class="pl-qv__opt"><span class="pl-qv__ol">' + o.name + '</span><div class="pl-qv__vals">';
      o.values.forEach(function (val) {
        var test = sel.slice(); test[i] = val;
        var ok = prod.variants.some(function (x) { return x.available && test.every(function (s, k) { return x['option' + (k + 1)] === s; }); });
        h += '<button type="button" class="pl-qv__v" data-i="' + i + '" data-v="' + val.replace(/"/g, '&quot;') + '" aria-pressed="' + (sel[i] === val) + '"' + (ok ? '' : ' disabled') + '></button>';
      });
      h += '</div></div>';
    });
    h += '<button type="button" class="pl-qv__btn pl-qv__btn--a" data-act="cart"' + (v && v.available ? '' : ' disabled') + '>' + (v && v.available ? 'Aggiungi al carrello' : 'Non disponibile') + '</button>';
    h += '<button type="button" class="pl-qv__btn pl-qv__btn--b" data-act="buy"' + (v && v.available ? '' : ' disabled') + '>Acquista ora</button>';
    h += '<p class="pl-qv__msg" role="status"></p><a class="pl-qv__full" href="' + prod.url + '">Vedi la scheda completa</a>';
    info.innerHTML = h;
    info.querySelector('.pl-qv__t').textContent = prod.title;
    info.querySelectorAll('.pl-qv__v').forEach(function (b) {
      b.textContent = b.getAttribute('data-v');
      b.addEventListener('click', function () { sel[+b.getAttribute('data-i')] = b.getAttribute('data-v'); render(); });
    });
    info.querySelectorAll('[data-act]').forEach(function (b) {
      b.addEventListener('click', function () { add(b.getAttribute('data-act')); });
    });
  }

  function add(act) {
    var v = current(); if (!v) return;
    var m = dlg.querySelector('.pl-qv__msg');
    m.textContent = 'Un attimo...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        if (act === 'buy') { window.location.href = '/checkout'; return; }
        m.innerHTML = 'Aggiunto al carrello. <a href="/cart">Vai al carrello</a>';
        ['cart:refresh', 'cart:change'].forEach(function (n) { document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
      })
      .catch(function () { m.textContent = 'Non è stato possibile aggiungere l’articolo. Riprova o apri la scheda prodotto.'; });
  }

  function open(handle, href) {
    ensure();
    fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function (p) {
      prod = p;
      var first = p.variants.find(function (x) { return x.available; }) || p.variants[0];
      sel = p.options.map(function (o, i) { return first['option' + (i + 1)]; });
      render();
      if (!dlg.open) dlg.showModal();
    }).catch(function () { window.location.href = href; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.pl-hs[data-handle]');
    if (!a) return;
    e.preventDefault();
    open(a.getAttribute('data-handle'), a.href);
  });
})();
